import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "../components/partial/Navbar";
import Footer from "../components/partial/Footer";
import themeImg from "../asset/theme.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAllThemeQuery } from "../../redux/API/ThemeApi";
import { useAllReferencePackagesQuery, useReferencePackageBySlugQuery } from "../../redux/API/ReferenceApi";
import PackageCard from "../components/card/PackageCard";

import { ImgUrl, themeImgUrl } from "../../constant";
import placeholderImg from "../asset/ghumneplaceholder.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { referencePackageImgUrl } from "../../constant";

const Theme = () => {
  const {slug} = useParams()
  const { data: themeData } = useAllThemeQuery();
  const { data: allRelatedData } = useAllReferencePackagesQuery();

  useEffect(() => {
    AOS.init({
      delay: 100,
      duration: 600,
      easing: "ease",
      once: false,
      mirror: false,
    });
  }, []);

  return (
    <>
      <Navbar />
      <div className="hero_banner">
        <img src={themeImg} alt="" className="w-100 h-100" />
      </div>
      <section className="mt-3 container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/" className="text-success">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Themes
            </li>
          </ol>
        </nav>

        <div className="row gy-3">
          <h2 className="text-center">Themes</h2>
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            className="mySwiper"
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 10,
              },
            }}
          >
            {themeData?.themes && themeData.themes.length > 0 ? (
              themeData.themes.map((theme) => (
                <div key={theme._id} className="col-lg-3 col-md-6">
                  <SwiperSlide>
                    <Link
                      to={`/theme/${theme.slug}`}
                      className="text-decoration-none"
                    >
                      <div className="theme-card position-relative rounded-3 overflow-hidden">
                        <img
                          src={`${ImgUrl}${themeImgUrl}${theme.image}`}
                          alt={theme.name}
                          onError={(e) => (e.target.src = placeholderImg)}
                          className="w-100 h-100 object-fit-cover"
                        />
                        <h4 className="position-absolute bottom-0 left-0 text-white text-center fw-semibold fs-6 theme-bg">
                          {theme.name}
                        </h4>
                      </div>
                    </Link>
                  </SwiperSlide>
                </div>
              ))
            ) : (
              <p className="text-center">No themes available</p>
            )}
          </Swiper>
        </div>
        <h4 className="mt-5 mb-3">Related Packages</h4>

        <div className="row gy-3">
          {allRelatedData?.relatedPackages &&
          allRelatedData.relatedPackages.length > 0 ? (
            allRelatedData.relatedPackages.map((packageItem) => (
              <div key={packageItem._id} className="col-lg-4">
                <Link
                  to={`/relatedpackage/${packageItem?.slug}`}
                  className="text-decoration-none text-unset"
                >
                  <PackageCard
                    title={packageItem?.name}
                    location={packageItem?.destinationId?.name}
                    price={packageItem?.price}
                    img={`${ImgUrl}${referencePackageImgUrl}${packageItem?.image}`}
                    itinerary={packageItem?.itinerary}
                    otherInfo={packageItem?.otherInfo}
                    overview={packageItem?.overview}
                    alt="Package Image"
                  />
                </Link>
              </div>
            ))
          ) : (
            <p className="text-center">No Related Packages Available</p>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Theme;
